import { render, staticRenderFns } from "./DistributedCashbackMetrics.vue?vue&type=template&id=56b67ac4&scoped=true"
import script from "./DistributedCashbackMetrics.vue?vue&type=script&lang=js"
export * from "./DistributedCashbackMetrics.vue?vue&type=script&lang=js"
import style0 from "./DistributedCashbackMetrics.vue?vue&type=style&index=0&id=56b67ac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b67ac4",
  null
  
)

export default component.exports